<template>
  <component
    :is="windowWidth > 1024 ? 's-modal' : 's-bottom-sheet'"
    cluster="k"
    :value="value"
    expanded
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    :show-close-icon="false"
    centered
    size="user-verification"
    body-class="body-verification"
    content-class="modal-content-semi_round"
    :visible="value"
  >
    <div>
      <pin-container
        :key="`attempt-otp-${attempt}`"
        :max-input="pinMaxInput"
        :is-error="!!otpSubmitErrorMessageInfo"
        :error-message="otpSubmitErrorMessageInfo"
        show-input-number
        @change="handleEachInput($event)"
        @resetstate="otpSubmitErrorMessageInfo = ''"
      >
        <template #header>
          <div class="text-container">
            <img
              src="https://cdn.karier.mu/assets/kariermu/pin/pin-baru.svg"
              alt="verification-pin"
              class="pin-illustration"
            >
            <p class="m-0 font-body-1-new text-royal-navy-900">
              Masukkan Kode Verifikasi
            </p>
            <p class="font-paragraph-5 header-description">
              Kode verifikasi telah dikirimkan ke email <strong>{{ userInfo.email }}</strong>. Silakan gunakan kode tersebut untuk verifikasi akun.
            </p>
          </div>
        </template>

        <template #footer>
          <div class="text-container">
            <p class="font-paragraph-5 email-sent-question">
              Belum menerima kode verifikasi melalui email?
            </p>
            <s-button
              id="request-otp-button"
              cluster="k"
              size="small"
              variant="ghost"
              :disabled="!canSendOTP"
              :loading="loadingSendOTP"
              class="font-label-1"
              @click="requestOTP()"
            >
              Kirim Ulang Kode Verifikasi
              <span
                v-if="!canSendOTP"
                class="otp-countdown"
              >
                &nbsp;({{ countdownDisplay }})
              </span>
            </s-button>
            <h5 class="font-body-3 meta-info"><span>atau</span></h5>
            <div>
              <div class="bottom-button-container">
                <s-button
                  id="change-email-button"
                  cluster="k"
                  variant="text"
                  class="font-label-1"
                  @click="$emit('change:email')"
                >
                  Ubah Email
                </s-button>
              </div>
              <div
                v-if="!hideSkipVerification"
                class="bottom-button-container"
              >
                <s-button
                  id="skip-verification-button"
                  cluster="k"
                  variant="text"
                  @click="skipVerification"
                >
                  Lewati Verifikasi Akun
                </s-button>
              </div>
            </div>
          </div>
        </template>
      </pin-container>

      <error-message-modal
        :is-open-modal="isOpenModalError"
        title="Verifikasi Akun Diberhentikan Sementara"
        illustration="https://cdn.karier.mu/assets/v3/default-illustration/verifikasi-diberhentikan-sementara.webp"
        description="Anda telah 5 kali salah memasukkan kode. Silakan lakukan verifikasi kembali setelah 10 menit."
        @onCloseModal="closeModalErrorMessage"
      ></error-message-modal>
    </div>
  </component>
</template>

<script>
import { mapState } from 'vuex'
import UserAPI from '@/api/user'
import ResizeListener from '@/mixins/resizeListener.js'
import ErrorMessageModal from '@/components/molecules/modals/ErrorMessageModal.vue'
import PinContainer from '@/components/payment/PinContainer.vue'

export default {
  name: 'BaseOtpUserVerificationV2',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    hideSkipVerification: Boolean
  },
  components: {
    ErrorMessageModal,
    PinContainer
  },
  mixins: [ResizeListener],
  data () {
    return {
      pinMaxInput: 6,

      // input OTP
      attempt: 0,
      isOpenModalError: false,
      otpSubmitErrorMessageInfo: '',

      // countdown
      sendOTPdelay: 90,
      countdownMinute: 0,
      countdownSecond: 0,
      setCountdownInterval: null,
      loadingSendOTP: false,

      // status code
      verificationFreezeStatusCode: 124
    }
  },
  computed: {
    ...mapState('storage', ['accessToken']),
    ...mapState('user', ['userInfo', 'isVerificationMandatory']),
    countdownDisplay () {
      return `${this.countdownMinute < 10 ? '0' : ''}${this.countdownMinute}:${this.countdownSecond < 10 ? '0' : ''}${this.countdownSecond}`
    },
    canSendOTP: {
      get () {
        return this.$store.state.user.canSendOTP
      },
      set (value) {
        this.$store.commit('user/CHANGE_CAN_SEND_OTP', value)
      }
    },
    isTemporarilyFreezeOtpVerification: {
      get () {
        return this.$store.state.user.isTemporarilyFreezeOtpVerification
      },
      set (val) {
        this.$store.commit('user/CHANGE_IS_TEMPORARILY_FREEZE_OTP_VERIFICATION', val)
      }
    }
  },
  methods: {
    async sendOTP (pin) {
      this.isLoadingSendOTP = true
      try {
        const { data } = await UserAPI.verifyEmailOTP(this.accessToken, {
          otp: pin
        })
        if (data.status === 200) {
          this.$store.commit('user/SET_USER', {
            ...this.userInfo,
            is_email_verified: true
          })
          this.$emit('openAlert', 'Selamat! Akun Anda terverifikasi')
          this.$emit('doneVerification')
        } else {
          throw data
        }
      } catch (error) {
        this.otpSubmitErrorMessageInfo = 'Kode verifikasi tidak sesuai'
        if (error.status === this.verificationFreezeStatusCode) {
          this.$store.commit('user/CHANGE_UNFREEZE_VERIFICATION_SNACKBAR_TEXT_TYPE', 'wasDisabled')
          this.isOpenModalError = true

          this.setupTimerFreezeOtpVerification()
        }
      } finally {
        this.isLoadingSendOTP = false
      }
    },
    async requestOTP () {
      if (!this.loadingSendOTP && this.canSendOTP) {
        this.loadingSendOTP = true
        try {
          const { data } = await UserAPI.sendEmailOTP(this.accessToken)
          if (data.status === 200) {
            this.canSendOTP = false
            this.setCountdownOTP()
          } else {
            throw data
          }
        } catch (error) {

        } finally {
          this.loadingSendOTP = false
        }
      }
    },
    async skipVerification () {
      try {
        const { data } = await UserAPI.sendSkipEmailOTP(this.accessToken)
        if (data.status === 200) {
          this.$emit('openAlert', 'Selamat Akun Anda telah terdaftar')
          this.$emit('skipVerification')
        } else {
          throw data
        }
      } catch (error) {
      }
    },
    handleEachInput (pin) {
      if (!pin.length) return
      if (pin.length !== this.pinMaxInput) {
        this.otpSubmitErrorMessageInfo = ''
        return
      }
      this.sendOTP(pin)
    },
    setupTimerFreezeOtpVerification () {
      this.isTemporarilyFreezeOtpVerification = true

      const freezeDurationInMinutes = 10
      const freezingTime = 1000 * 60 * freezeDurationInMinutes
      const timeNow = new Date()
      const timeUnfreeze = new Date()
      timeUnfreeze.setTime(timeNow.getTime() + freezingTime)
      const unfreezeTimestamp = Date.parse(timeUnfreeze)
      localStorage.setItem('freezing-verification-timestamp', unfreezeTimestamp)

      setTimeout(() => {
        this.isTemporarilyFreezeOtpVerification = false
        this.$store.commit('user/CHANGE_IS_SHOW_UNFREEZE_SNACKBAR', true)
      }, freezingTime)
    },
    setCountdownOTP () {
      const timeNow = new Date()
      const timeOtp = new Date()
      timeOtp.setTime(timeNow.getTime() + (this.sendOTPdelay * 1000))
      const otpTimestamp = Date.parse(timeOtp)

      localStorage.setItem('OTP-timestamp', otpTimestamp)
      this.countdownCount()
      this.startCountdownOTP()
    },
    countdownCount () {
      const countDate = new Date(Number(localStorage.getItem('OTP-timestamp'))).getTime()
      const now = new Date().getTime()
      const gap = countDate - now

      const second = 1000
      const minute = second * 60
      const hour = minute * 60

      this.countdownMinute = Math.floor((gap % hour) / minute)
      this.countdownSecond = Math.floor((gap % minute) / second)
    },
    stopCountdownOTP () {
      if (this.setCountdownInterval) {
        clearInterval(this.setCountdownInterval)
        localStorage.removeItem('OTP-timestamp')
      }
    },
    startCountdownOTP () {
      this.setCountdownInterval = setInterval(() => {
        this.countdownCount()
        if (this.countdownSecond <= 0 && this.countdownMinute <= 0) {
          this.stopCountdownOTP()
          this.canSendOTP = true
        }
      }, 1000)
    },
    checkResCountdown () {
      if ((localStorage.getItem('OTP-timestamp'))) {
        const countDate = new Date(Number(localStorage.getItem('OTP-timestamp'))).getTime()
        const now = new Date().getTime()
        const gap = countDate - now
        if (gap > 0) {
          this.canSendOTP = false
          this.countdownCount()
          this.startCountdownOTP()
        }
      }
    },
    closeModalErrorMessage () {
      this.isOpenModalError = false
      if (this.isVerificationMandatory) {
        this.$router.go(-1)
      } else {
        this.$store.commit('user/CHANGE_IS_VERIFICATION_MANDATORY', false)
        this.$store.commit('user/CHANGE_IS_HIDE_SKIP_VERIFICATION', false)
        this.$store.commit('user/CHANGE_IS_OPEN_VERIFICATION_INVITATION', false)
        this.$store.commit('user/CHANGE_IS_OPEN_VERIFICATION_OTP', false)
        this.$emit('openAlert', 'Selamat Akun Anda telah terdaftar')
        this.$router.push('/')
      }
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.canSendOTP = false
        this.setCountdownOTP()
      }
    },
    otpSubmitErrorMessageInfo (value) {
      if (value) {
        this.attempt += 1
      }
    },
    canSendOTP (value) {
      if (!value) {
        this.checkResCountdown()
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.checkResCountdown()
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.text-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
  width: 100%;
  margin-top: 40px;
}

.email-sent-question {
  margin: 0;
  margin-top: 8px;
  color: var(--color-text-primary);
}

.pin-illustration {
  margin: auto;
  width: 48px;
  height: 48px;
}

.header-description {
  margin: 0;
  text-align: center;
  word-break: break-word;
  color: var(--color-text-primary);
}

.otp-countdown {
  color: var(--color-ui-text-link);
}

.meta-info {
  width: 100%;
  text-align: center;
  color: var(--color-ui-text-tertiary-2);
  border-bottom: 1px solid var(--color-ui-element-smoke-grey);
  line-height: 0.1em;
}

.meta-info span {
  background: var(--color-background-white);
  padding: 0 10px;
}

:deep {
  .s-modal-container {
    width: 498px;
    min-height: 353px;
  }

  .s-modal-container {
    .s-modal-header {
      padding-bottom: 0 !important;
      border-bottom: none !important;
    }
    .s-modal-footer {
      padding-top: 0 !important;
      border-top: none !important;
    }
  }
}

@media screen and (min-width: 1024px) {
  .text-container {
    margin-top: 0;
  }

  ::v-deep .modal-user-verification {
    width: 420px;
  }

  ::v-deep .body-verification {
    padding: 8px 24px;
  }
}
</style>
